module.exports = __webpack_public_path__ + "img/longsword.68a8c99f.png";